// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fn","advertDetailContacts__header":"c-n_fo"};